namespace Matrix.Data {
    export interface SecurityMergeForm {
        Name: Serenity.StringEditor;
        SourceCode: Serenity.StringEditor;
        SourceSecurityId: Serenity.StringEditor;
        SecurityTypeCode: Serenity.StringEditor;
        Issuer: Serenity.StringEditor;
        IssuerCode: FormatLookupEditor;
        LocalCurrencyCode: Serenity.StringEditor;
        ExposureMultiplier: Serenity.DecimalEditor;
        AssociatedAccountCode: Serenity.StringEditor;
        CountryOfIssueCode: Serenity.StringEditor;
        CountryOfRiskCode: Serenity.StringEditor;
        CurrencyOfRiskCode: Serenity.StringEditor;
        Sedol: Serenity.StringEditor;
        RIC: Serenity.StringEditor;
        Isin: Serenity.StringEditor;
        Cusip: Serenity.StringEditor;
        Figi: Serenity.StringEditor;
        Ticker: Serenity.StringEditor;
        InternalSecurityCode: Serenity.StringEditor;
        SecurityId: Serenity.IntegerEditor;
        DealParentCode: Serenity.StringEditor;
        ClearerReference: Serenity.StringEditor;
        RedCode: Serenity.StringEditor;
        SpLtRating: Serenity.StringEditor;
        SpStRating: Serenity.StringEditor;
        MoodysLtRating: Serenity.StringEditor;
        MoodysStRating: Serenity.StringEditor;
        FitchLtRating: Serenity.StringEditor;
        FitchStRating: Serenity.StringEditor;
        InternalLtRating: Serenity.StringEditor;
        InternalStRating: Serenity.StringEditor;
        CouponRate: Serenity.DecimalEditor;
        MaturityDate: Serenity.DateEditor;
        FixedOrFloat: Serenity.StringEditor;
        FloatIndex: Serenity.StringEditor;
        InflationIndexLag: Serenity.StringEditor;
        InterestTerm: Serenity.StringEditor;
        Spread: Serenity.DecimalEditor;
        AllIn: Serenity.DecimalEditor;
        InterestCcy: Serenity.StringEditor;
        PaymentFrequency: Serenity.StringEditor;
        PaymentBusDayConvention: Serenity.StringEditor;
        PaymentCalendar: Serenity.StringEditor;
        FirstPaymentDate: Serenity.DateEditor;
        DayCountBasis: Serenity.StringEditor;
        ResetFrequency: Serenity.StringEditor;
        ResetBusDayConvention: Serenity.StringEditor;
        ResetCalendar: Serenity.StringEditor;
        CreditEvents: Serenity.StringEditor;
        Guarantor: Serenity.StringEditor;
        TradeDate: Serenity.DateEditor;
        EffectiveDate: Serenity.DateEditor;
        BrokerCode: FormatLookupEditor;
        Strategy: Serenity.StringEditor;
        OptionStyle: Serenity.StringEditor;
        ExerciseStyle: Serenity.StringEditor;
        PutOrCall: Serenity.StringEditor;
        StrikePrice: Serenity.DecimalEditor;
        StrikeCurrency: Serenity.StringEditor;
        Premium: Serenity.DecimalEditor;
        PremiumCcy: Serenity.StringEditor;
        PayOrRec: Serenity.StringEditor;
        BorrowerCode: FormatLookupEditor;
        GicsSelection: ModelTargetPicker;
        GicsSector: Serenity.StringEditor;
        GicsIndustryGroup: Serenity.StringEditor;
        GicsIndustry: Serenity.StringEditor;
        GicsSubIndustry: Serenity.StringEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        MatchedToSourceCode: StaticTextBlock;
        MatchedToSourceSecurityId: StaticTextBlock;
        MatchedBy: StaticTextBlock;
        MatchedWhen: ReadOnlyDateTime;
        RepairedBy: StaticTextBlock;
        RepairedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class SecurityMergeForm extends Serenity.PrefixedContext {
        static formKey = 'Data.SecurityMerge';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SecurityMergeForm.init)  {
                SecurityMergeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = FormatLookupEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.DateEditor;
                var w5 = ModelTargetPicker;
                var w6 = StaticTextBlock;
                var w7 = ReadOnlyDateTime;

                Q.initFormType(SecurityMergeForm, [
                    'Name', w0,
                    'SourceCode', w0,
                    'SourceSecurityId', w0,
                    'SecurityTypeCode', w0,
                    'Issuer', w0,
                    'IssuerCode', w1,
                    'LocalCurrencyCode', w0,
                    'ExposureMultiplier', w2,
                    'AssociatedAccountCode', w0,
                    'CountryOfIssueCode', w0,
                    'CountryOfRiskCode', w0,
                    'CurrencyOfRiskCode', w0,
                    'Sedol', w0,
                    'RIC', w0,
                    'Isin', w0,
                    'Cusip', w0,
                    'Figi', w0,
                    'Ticker', w0,
                    'InternalSecurityCode', w0,
                    'SecurityId', w3,
                    'DealParentCode', w0,
                    'ClearerReference', w0,
                    'RedCode', w0,
                    'SpLtRating', w0,
                    'SpStRating', w0,
                    'MoodysLtRating', w0,
                    'MoodysStRating', w0,
                    'FitchLtRating', w0,
                    'FitchStRating', w0,
                    'InternalLtRating', w0,
                    'InternalStRating', w0,
                    'CouponRate', w2,
                    'MaturityDate', w4,
                    'FixedOrFloat', w0,
                    'FloatIndex', w0,
                    'InflationIndexLag', w0,
                    'InterestTerm', w0,
                    'Spread', w2,
                    'AllIn', w2,
                    'InterestCcy', w0,
                    'PaymentFrequency', w0,
                    'PaymentBusDayConvention', w0,
                    'PaymentCalendar', w0,
                    'FirstPaymentDate', w4,
                    'DayCountBasis', w0,
                    'ResetFrequency', w0,
                    'ResetBusDayConvention', w0,
                    'ResetCalendar', w0,
                    'CreditEvents', w0,
                    'Guarantor', w0,
                    'TradeDate', w4,
                    'EffectiveDate', w4,
                    'BrokerCode', w1,
                    'Strategy', w0,
                    'OptionStyle', w0,
                    'ExerciseStyle', w0,
                    'PutOrCall', w0,
                    'StrikePrice', w2,
                    'StrikeCurrency', w0,
                    'Premium', w2,
                    'PremiumCcy', w0,
                    'PayOrRec', w0,
                    'BorrowerCode', w1,
                    'GicsSelection', w5,
                    'GicsSector', w0,
                    'GicsIndustryGroup', w0,
                    'GicsIndustry', w0,
                    'GicsSubIndustry', w0,
                    'CreatedBy', w6,
                    'CreatedWhen', w7,
                    'UpdatedBy', w6,
                    'UpdatedWhen', w7,
                    'MatchedToSourceCode', w6,
                    'MatchedToSourceSecurityId', w6,
                    'MatchedBy', w6,
                    'MatchedWhen', w7,
                    'RepairedBy', w6,
                    'RepairedWhen', w7,
                    'Version', w6
                ]);
            }
        }
    }
}
